<template>
  <div class="page-content row" id="Mails">
    <div class="col s12 m11 main-page-content">

      <div class="col l3 sidebar hide-on-med-and-down">
        <div class="card">
          <user-info />
        </div>

        <div class="card">
          <find-us/>
        </div>
      </div>

      <div class="col s12 l9 ">
        <div class="card standard-card stats-card">
          <complete-process />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FindUs from '@/components/findUs'
import UserInfo from '@/components/userInfo'
import CompleteProcess from '@/components/completeProcess'
export default {
  name: 'ProcessLead',
  components: { UserInfo, FindUs, CompleteProcess }
}
</script>
<style lang="scss">
@import 'src/pages/dashboard/base';
</style>



// WEBPACK FOOTER //
// processLead.vue?68b13802